import { Action, IOperation } from "./types";

export enum Key {
	backspace = 8,
	enter = 13,
	tab = 9,
	esc = 27,
	space = 32,
	left = 37,
	up = 38,
	right = 39,
	down = 40,
	insert = 45,
	del = 46,
	ctrl = 17,
	a = 65,
	b = 66,
	c = 67,
	s = 83,
	u = 85,
	v = 86,
	x = 88,
	y = 89,
	z = 90,
	i = 73,
}

function ctrlKey(e: KeyboardEvent): IOperation {
	const key = e.which;
	switch (key) {
		case Key.z:
			return {
				action: e.shiftKey ? Action.redo : Action.undo,
			};
		case Key.y:
			return {
				action: Action.redo,
			};
		case Key.a:
			return {
				action: Action.selectAll,
			};
		case Key.v:
		case Key.x:
		case Key.c:
			return;
		case Key.u:
		case Key.i:
		case Key.b:
			e.preventDefault();
			return;
	}
	return;
}

export function keyToOperation(e: KeyboardEvent): IOperation {
	if (e.shiftKey && e.which === Key.enter) {
		e.preventDefault();
		return {
			action: Action.add,
			data: "\n",
		};
	}

	switch (e.which) {
		case Key.insert:
			e.preventDefault();
			return;
		case Key.left:
		case Key.right:
		case Key.down:
		case Key.up:
			return;
		case Key.backspace:
			e.preventDefault();
			return {
				action: Action.remove,
				data: true,
			};
		case Key.del:
			e.preventDefault();
			return {
				action: Action.remove,
				data: false,
			};
		case Key.space:
			e.preventDefault();
			return {
				action: Action.add,
				data: " ",
			};
		case Key.enter:
			e.preventDefault();
			return {
				action: Action.add,
				data: { newBlock: true },
			};
	}

	if (e.ctrlKey || e.metaKey) {
		return ctrlKey(e);
	}

	const char = e.key;
	if (char.length > 1 || e.altKey) {
		return;
	}

	e.preventDefault();
	return {
		action: Action.add,
		data: char,
	};
}
